var items = {
  "block.minecraft.air": "空気",
  "block.minecraft.stone": "石",
  "block.minecraft.granite": "花崗岩",
  "block.minecraft.polished_granite": "磨かれた花崗岩",
  "block.minecraft.diorite": "閃緑岩",
  "block.minecraft.polished_diorite": "磨かれた閃緑岩",
  "block.minecraft.andesite": "安山岩",
  "block.minecraft.polished_andesite": "磨かれた安山岩",
  "block.minecraft.grass_block": "草ブロック",
  "block.minecraft.dirt": "土",
  "block.minecraft.coarse_dirt": "粗い土",
  "block.minecraft.podzol": "ポドゾル",
  "block.minecraft.crimson_nylium": "真紅のナイリウム",
  "block.minecraft.warped_nylium": "歪んだナイリウム",
  "block.minecraft.cobblestone": "丸石",
  "block.minecraft.oak_planks": "オークの板材",
  "block.minecraft.spruce_planks": "トウヒの板材",
  "block.minecraft.birch_planks": "シラカバの板材",
  "block.minecraft.jungle_planks": "ジャングルの板材",
  "block.minecraft.acacia_planks": "アカシアの板材",
  "block.minecraft.dark_oak_planks": "ダークオークの板材",
  "block.minecraft.crimson_planks": "真紅の板材",
  "block.minecraft.warped_planks": "歪んだ板材",
  "block.minecraft.oak_sapling": "オークの苗木",
  "block.minecraft.spruce_sapling": "トウヒの苗木",
  "block.minecraft.birch_sapling": "シラカバの苗木",
  "block.minecraft.jungle_sapling": "ジャングルの苗木",
  "block.minecraft.acacia_sapling": "アカシアの苗木",
  "block.minecraft.dark_oak_sapling": "ダークオークの苗木",
  "block.minecraft.bedrock": "岩盤",
  "block.minecraft.sand": "砂",
  "block.minecraft.red_sand": "赤い砂",
  "block.minecraft.gravel": "砂利",
  "block.minecraft.gold_ore": "金鉱石",
  "block.minecraft.iron_ore": "鉄鉱石",
  "block.minecraft.coal_ore": "石炭鉱石",
  "block.minecraft.nether_gold_ore": "ネザー金鉱石",
  "block.minecraft.oak_log": "オークの原木",
  "block.minecraft.spruce_log": "トウヒの原木",
  "block.minecraft.birch_log": "シラカバの原木",
  "block.minecraft.jungle_log": "ジャングルの原木",
  "block.minecraft.acacia_log": "アカシアの原木",
  "block.minecraft.dark_oak_log": "ダークオークの原木",
  "block.minecraft.crimson_stem": "真紅の幹",
  "block.minecraft.warped_stem": "歪んだ幹",
  "block.minecraft.stripped_oak_log": "樹皮を剥いだオークの原木",
  "block.minecraft.stripped_spruce_log": "樹皮を剥いだトウヒの原木",
  "block.minecraft.stripped_birch_log": "樹皮を剥いだシラカバの原木",
  "block.minecraft.stripped_jungle_log": "樹皮を剥いだジャングルの原木",
  "block.minecraft.stripped_acacia_log": "樹皮を剥いだアカシアの原木",
  "block.minecraft.stripped_dark_oak_log": "樹皮を剥いだダークオークの原木",
  "block.minecraft.stripped_crimson_stem": "表皮を剥いだ真紅の幹",
  "block.minecraft.stripped_warped_stem": "表皮を剥いだ歪んだ幹",
  "block.minecraft.stripped_oak_wood": "樹皮を剥いだオークの木",
  "block.minecraft.stripped_spruce_wood": "樹皮を剥いだトウヒの木",
  "block.minecraft.stripped_birch_wood": "樹皮を剥いだシラカバの木",
  "block.minecraft.stripped_jungle_wood": "樹皮を剥いだジャングルの木",
  "block.minecraft.stripped_acacia_wood": "樹皮を剥いだアカシアの木",
  "block.minecraft.stripped_dark_oak_wood": "樹皮を剥いだダークオークの木",
  "block.minecraft.stripped_crimson_hyphae": "表皮を剥いだ真紅の菌糸",
  "block.minecraft.stripped_warped_hyphae": "表皮を剥いだ歪んだ菌糸",
  "block.minecraft.oak_wood": "オークの木",
  "block.minecraft.spruce_wood": "トウヒの木",
  "block.minecraft.birch_wood": "シラカバの木",
  "block.minecraft.jungle_wood": "ジャングルの木",
  "block.minecraft.acacia_wood": "アカシアの木",
  "block.minecraft.dark_oak_wood": "ダークオークの木",
  "block.minecraft.crimson_hyphae": "真紅の菌糸",
  "block.minecraft.warped_hyphae": "歪んだ菌糸",
  "block.minecraft.oak_leaves": "オークの葉",
  "block.minecraft.spruce_leaves": "トウヒの葉",
  "block.minecraft.birch_leaves": "シラカバの葉",
  "block.minecraft.jungle_leaves": "ジャングルの葉",
  "block.minecraft.acacia_leaves": "アカシアの葉",
  "block.minecraft.dark_oak_leaves": "ダークオークの葉",
  "block.minecraft.sponge": "スポンジ",
  "block.minecraft.wet_sponge": "濡れたスポンジ",
  "block.minecraft.glass": "ガラス",
  "block.minecraft.lapis_ore": "ラピスラズリ鉱石",
  "block.minecraft.lapis_block": "ラピスラズリブロック",
  "block.minecraft.dispenser": "ディスペンサー",
  "block.minecraft.sandstone": "砂岩",
  "block.minecraft.chiseled_sandstone": "模様入りの砂岩",
  "block.minecraft.cut_sandstone": "研がれた砂岩",
  "block.minecraft.note_block": "音符ブロック",
  "block.minecraft.powered_rail": "パワードレール",
  "block.minecraft.detector_rail": "ディテクターレール",
  "block.minecraft.sticky_piston": "粘着ピストン",
  "block.minecraft.cobweb": "クモの巣",
  "block.minecraft.grass": "草",
  "block.minecraft.fern": "シダ",
  "block.minecraft.dead_bush": "枯れ木",
  "block.minecraft.seagrass": "海草",
  "block.minecraft.sea_pickle": "シーピクルス",
  "block.minecraft.piston": "ピストン",
  "block.minecraft.white_wool": "白色の羊毛",
  "block.minecraft.orange_wool": "橙色の羊毛",
  "block.minecraft.magenta_wool": "赤紫色の羊毛",
  "block.minecraft.light_blue_wool": "空色の羊毛",
  "block.minecraft.yellow_wool": "黄色の羊毛",
  "block.minecraft.lime_wool": "黄緑色の羊毛",
  "block.minecraft.pink_wool": "桃色の羊毛",
  "block.minecraft.gray_wool": "灰色の羊毛",
  "block.minecraft.light_gray_wool": "薄灰色の羊毛",
  "block.minecraft.cyan_wool": "青緑色の羊毛",
  "block.minecraft.purple_wool": "紫色の羊毛",
  "block.minecraft.blue_wool": "青色の羊毛",
  "block.minecraft.brown_wool": "茶色の羊毛",
  "block.minecraft.green_wool": "緑色の羊毛",
  "block.minecraft.red_wool": "赤色の羊毛",
  "block.minecraft.black_wool": "黒色の羊毛",
  "block.minecraft.dandelion": "タンポポ",
  "block.minecraft.poppy": "ポピー",
  "block.minecraft.blue_orchid": "ヒスイラン",
  "block.minecraft.allium": "アリウム",
  "block.minecraft.azure_bluet": "ヒナソウ",
  "block.minecraft.red_tulip": "赤色のチューリップ",
  "block.minecraft.orange_tulip": "橙色のチューリップ",
  "block.minecraft.white_tulip": "白色のチューリップ",
  "block.minecraft.pink_tulip": "桃色のチューリップ",
  "block.minecraft.oxeye_daisy": "フランスギク",
  "block.minecraft.cornflower": "ヤグルマギク",
  "block.minecraft.lily_of_the_valley": "スズラン",
  "block.minecraft.wither_rose": "ウィザーローズ",
  "block.minecraft.brown_mushroom": "茶色のキノコ",
  "block.minecraft.red_mushroom": "赤色のキノコ",
  "block.minecraft.crimson_fungus": "真紅のキノコ",
  "block.minecraft.warped_fungus": "歪んだキノコ",
  "block.minecraft.crimson_roots": "真紅の根",
  "block.minecraft.warped_roots": "歪んだ根",
  "block.minecraft.nether_sprouts": "ネザースプラウト",
  "block.minecraft.weeping_vines": "しだれツタ",
  "block.minecraft.twisting_vines": "ねじれツタ",
  "block.minecraft.sugar_cane": "サトウキビ",
  "block.minecraft.kelp": "コンブ",
  "block.minecraft.bamboo": "竹",
  "block.minecraft.gold_block": "金ブロック",
  "block.minecraft.iron_block": "鉄ブロック",
  "block.minecraft.oak_slab": "オークのハーフブロック",
  "block.minecraft.spruce_slab": "トウヒのハーフブロック",
  "block.minecraft.birch_slab": "シラカバのハーフブロック",
  "block.minecraft.jungle_slab": "ジャングルのハーフブロック",
  "block.minecraft.acacia_slab": "アカシアのハーフブロック",
  "block.minecraft.dark_oak_slab": "ダークオークのハーフブロック",
  "block.minecraft.crimson_slab": "真紅のハーフブロック",
  "block.minecraft.warped_slab": "歪んだハーフブロック",
  "block.minecraft.stone_slab": "石のハーフブロック",
  "block.minecraft.smooth_stone_slab": "滑らかな石のハーフブロック",
  "block.minecraft.sandstone_slab": "砂岩のハーフブロック",
  "block.minecraft.cut_sandstone_slab": "研がれた砂岩のハーフブロック",
  "block.minecraft.petrified_oak_slab": "石化したオークのハーフブロック",
  "block.minecraft.cobblestone_slab": "丸石のハーフブロック",
  "block.minecraft.brick_slab": "レンガのハーフブロック",
  "block.minecraft.stone_brick_slab": "石レンガのハーフブロック",
  "block.minecraft.nether_brick_slab": "ネザーレンガのハーフブロック",
  "block.minecraft.quartz_slab": "クォーツのハーフブロック",
  "block.minecraft.red_sandstone_slab": "赤い砂岩のハーフブロック",
  "block.minecraft.cut_red_sandstone_slab": "研がれた赤い砂岩のハーフブロック",
  "block.minecraft.purpur_slab": "プルプァのハーフブロック",
  "block.minecraft.prismarine_slab": "プリズマリンのハーフブロック",
  "block.minecraft.prismarine_brick_slab": "プリズマリンレンガのハーフブロック",
  "block.minecraft.dark_prismarine_slab": "ダークプリズマリンのハーフブロック",
  "block.minecraft.smooth_quartz": "滑らかなクォーツブロック",
  "block.minecraft.smooth_red_sandstone": "滑らかな赤い砂岩",
  "block.minecraft.smooth_sandstone": "滑らかな砂岩",
  "block.minecraft.smooth_stone": "滑らかな石",
  "block.minecraft.bricks": "レンガ",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "本棚",
  "block.minecraft.mossy_cobblestone": "苔むした丸石",
  "block.minecraft.obsidian": "黒曜石",
  "block.minecraft.torch": "松明",
  "block.minecraft.end_rod": "エンドロッド",
  "block.minecraft.chorus_plant": "コーラスプラント",
  "block.minecraft.chorus_flower": "コーラスフラワー",
  "block.minecraft.purpur_block": "プルプァブロック",
  "block.minecraft.purpur_pillar": "プルプァの柱",
  "block.minecraft.purpur_stairs": "プルプァの階段",
  "block.minecraft.spawner": "スポナー",
  "block.minecraft.oak_stairs": "オークの階段",
  "block.minecraft.chest": "チェスト",
  "block.minecraft.diamond_ore": "ダイヤモンド鉱石",
  "block.minecraft.diamond_block": "ダイヤモンドブロック",
  "block.minecraft.crafting_table": "作業台",
  "block.minecraft.farmland": "耕地",
  "block.minecraft.furnace": "かまど",
  "block.minecraft.ladder": "はしご",
  "block.minecraft.rail": "レール",
  "block.minecraft.cobblestone_stairs": "丸石の階段",
  "block.minecraft.lever": "レバー",
  "block.minecraft.stone_pressure_plate": "石の感圧板",
  "block.minecraft.oak_pressure_plate": "オークの感圧板",
  "block.minecraft.spruce_pressure_plate": "トウヒの感圧板",
  "block.minecraft.birch_pressure_plate": "シラカバの感圧板",
  "block.minecraft.jungle_pressure_plate": "ジャングルの感圧板",
  "block.minecraft.acacia_pressure_plate": "アカシアの感圧板",
  "block.minecraft.dark_oak_pressure_plate": "ダークオークの感圧板",
  "block.minecraft.crimson_pressure_plate": "真紅の感圧板",
  "block.minecraft.warped_pressure_plate": "歪んだ感圧板",
  "block.minecraft.polished_blackstone_pressure_plate": "磨かれたブラックストーンの感圧板",
  "block.minecraft.redstone_ore": "レッドストーン鉱石",
  "block.minecraft.redstone_torch": "レッドストーントーチ",
  "block.minecraft.snow": "雪",
  "block.minecraft.ice": "氷",
  "block.minecraft.snow_block": "雪ブロック",
  "block.minecraft.cactus": "サボテン",
  "block.minecraft.clay": "粘土",
  "block.minecraft.jukebox": "ジュークボックス",
  "block.minecraft.oak_fence": "オークのフェンス",
  "block.minecraft.spruce_fence": "トウヒのフェンス",
  "block.minecraft.birch_fence": "シラカバのフェンス",
  "block.minecraft.jungle_fence": "ジャングルのフェンス",
  "block.minecraft.acacia_fence": "アカシアのフェンス",
  "block.minecraft.dark_oak_fence": "ダークオークのフェンス",
  "block.minecraft.crimson_fence": "真紅のフェンス",
  "block.minecraft.warped_fence": "歪んだフェンス",
  "block.minecraft.pumpkin": "カボチャ",
  "block.minecraft.carved_pumpkin": "くり抜かれたカボチャ",
  "block.minecraft.netherrack": "ネザーラック",
  "block.minecraft.soul_sand": "ソウルサンド",
  "block.minecraft.soul_soil": "ソウルソイル",
  "block.minecraft.basalt": "玄武岩",
  "block.minecraft.polished_basalt": "磨かれた玄武岩",
  "block.minecraft.soul_torch": "魂の松明",
  "block.minecraft.glowstone": "グロウストーン",
  "block.minecraft.jack_o_lantern": "ジャック・オ・ランタン",
  "block.minecraft.oak_trapdoor": "オークのトラップドア",
  "block.minecraft.spruce_trapdoor": "トウヒのトラップドア",
  "block.minecraft.birch_trapdoor": "シラカバのトラップドア",
  "block.minecraft.jungle_trapdoor": "ジャングルのトラップドア",
  "block.minecraft.acacia_trapdoor": "アカシアのトラップドア",
  "block.minecraft.dark_oak_trapdoor": "ダークオークのトラップドア",
  "block.minecraft.crimson_trapdoor": "真紅のトラップドア",
  "block.minecraft.warped_trapdoor": "歪んだトラップドア",
  "block.minecraft.infested_stone": "虫食い石",
  "block.minecraft.infested_cobblestone": "虫食い丸石",
  "block.minecraft.infested_stone_bricks": "虫食い石レンガ",
  "block.minecraft.infested_mossy_stone_bricks": "苔むした虫食い石レンガ",
  "block.minecraft.infested_cracked_stone_bricks": "ひび割れた虫食い石レンガ",
  "block.minecraft.infested_chiseled_stone_bricks": "模様入りの虫食い石レンガ",
  "block.minecraft.stone_bricks": "石レンガ",
  "block.minecraft.mossy_stone_bricks": "苔むした石レンガ",
  "block.minecraft.cracked_stone_bricks": "ひび割れた石レンガ",
  "block.minecraft.chiseled_stone_bricks": "模様入りの石レンガ",
  "block.minecraft.brown_mushroom_block": "茶色のキノコブロック",
  "block.minecraft.red_mushroom_block": "赤色のキノコブロック",
  "block.minecraft.mushroom_stem": "キノコの柄",
  "block.minecraft.iron_bars": "鉄格子",
  "block.minecraft.chain": "鎖",
  "block.minecraft.glass_pane": "ガラス板",
  "block.minecraft.melon": "スイカ",
  "block.minecraft.vine": "ツタ",
  "block.minecraft.oak_fence_gate": "オークのフェンスゲート",
  "block.minecraft.spruce_fence_gate": "トウヒのフェンスゲート",
  "block.minecraft.birch_fence_gate": "シラカバのフェンスゲート",
  "block.minecraft.jungle_fence_gate": "ジャングルのフェンスゲート",
  "block.minecraft.acacia_fence_gate": "アカシアのフェンスゲート",
  "block.minecraft.dark_oak_fence_gate": "ダークオークのフェンスゲート",
  "block.minecraft.crimson_fence_gate": "真紅のフェンスゲート",
  "block.minecraft.warped_fence_gate": "歪んだフェンスゲート",
  "block.minecraft.brick_stairs": "レンガの階段",
  "block.minecraft.stone_brick_stairs": "石レンガの階段",
  "block.minecraft.mycelium": "菌糸",
  "block.minecraft.lily_pad": "スイレンの葉",
  "block.minecraft.nether_bricks": "ネザーレンガ",
  "block.minecraft.cracked_nether_bricks": "ひび割れたネザーレンガ",
  "block.minecraft.chiseled_nether_bricks": "模様入りのネザーレンガ",
  "block.minecraft.nether_brick_fence": "ネザーレンガのフェンス",
  "block.minecraft.nether_brick_stairs": "ネザーレンガの階段",
  "block.minecraft.enchanting_table": "エンチャントテーブル",
  "block.minecraft.end_portal_frame": "エンドポータルフレーム",
  "block.minecraft.end_stone": "エンドストーン",
  "block.minecraft.end_stone_bricks": "エンドストーンレンガ",
  "block.minecraft.dragon_egg": "ドラゴンの卵",
  "block.minecraft.redstone_lamp": "レッドストーンランプ",
  "block.minecraft.sandstone_stairs": "砂岩の階段",
  "block.minecraft.emerald_ore": "エメラルド鉱石",
  "block.minecraft.ender_chest": "エンダーチェスト",
  "block.minecraft.tripwire_hook": "トリップワイヤーフック",
  "block.minecraft.emerald_block": "エメラルドブロック",
  "block.minecraft.spruce_stairs": "トウヒの階段",
  "block.minecraft.birch_stairs": "シラカバの階段",
  "block.minecraft.jungle_stairs": "ジャングルの階段",
  "block.minecraft.crimson_stairs": "真紅の階段",
  "block.minecraft.warped_stairs": "歪んだ階段",
  "block.minecraft.command_block": "コマンドブロック",
  "block.minecraft.beacon": "ビーコン",
  "block.minecraft.cobblestone_wall": "丸石の塀",
  "block.minecraft.mossy_cobblestone_wall": "苔むした丸石の塀",
  "block.minecraft.brick_wall": "レンガの塀",
  "block.minecraft.prismarine_wall": "プリズマリンの塀",
  "block.minecraft.red_sandstone_wall": "赤い砂岩の塀",
  "block.minecraft.mossy_stone_brick_wall": "苔むした石レンガの塀",
  "block.minecraft.granite_wall": "花崗岩の塀",
  "block.minecraft.stone_brick_wall": "石レンガの塀",
  "block.minecraft.nether_brick_wall": "ネザーレンガの塀",
  "block.minecraft.andesite_wall": "安山岩の塀",
  "block.minecraft.red_nether_brick_wall": "赤いネザーレンガの塀",
  "block.minecraft.sandstone_wall": "砂岩の塀",
  "block.minecraft.end_stone_brick_wall": "エンドストーンレンガの塀",
  "block.minecraft.diorite_wall": "閃緑岩の塀",
  "block.minecraft.blackstone_wall": "ブラックストーンの塀",
  "block.minecraft.polished_blackstone_wall": "磨かれたブラックストーンの塀",
  "block.minecraft.polished_blackstone_brick_wall": "磨かれたブラックストーンレンガの塀",
  "block.minecraft.stone_button": "石のボタン",
  "block.minecraft.oak_button": "オークのボタン",
  "block.minecraft.spruce_button": "トウヒのボタン",
  "block.minecraft.birch_button": "シラカバのボタン",
  "block.minecraft.jungle_button": "ジャングルのボタン",
  "block.minecraft.acacia_button": "アカシアのボタン",
  "block.minecraft.dark_oak_button": "ダークオークのボタン",
  "block.minecraft.crimson_button": "真紅のボタン",
  "block.minecraft.warped_button": "歪んだボタン",
  "block.minecraft.polished_blackstone_button": "磨かれたブラックストーンのボタン",
  "block.minecraft.anvil": "金床",
  "block.minecraft.chipped_anvil": "欠けた金床",
  "block.minecraft.damaged_anvil": "壊れかけの金床",
  "block.minecraft.trapped_chest": "トラップチェスト",
  "block.minecraft.light_weighted_pressure_plate": "軽量用感圧板",
  "block.minecraft.heavy_weighted_pressure_plate": "重量用感圧板",
  "block.minecraft.daylight_detector": "日照センサー",
  "block.minecraft.redstone_block": "レッドストーンブロック",
  "block.minecraft.nether_quartz_ore": "ネザークォーツ鉱石",
  "block.minecraft.hopper": "ホッパー",
  "block.minecraft.chiseled_quartz_block": "模様入りのクォーツブロック",
  "block.minecraft.quartz_block": "クォーツブロック",
  "block.minecraft.quartz_bricks": "クォーツレンガ",
  "block.minecraft.quartz_pillar": "クォーツの柱",
  "block.minecraft.quartz_stairs": "クォーツの階段",
  "block.minecraft.activator_rail": "アクティベーターレール",
  "block.minecraft.dropper": "ドロッパー",
  "block.minecraft.white_terracotta": "白色のテラコッタ",
  "block.minecraft.orange_terracotta": "橙色のテラコッタ",
  "block.minecraft.magenta_terracotta": "赤紫色のテラコッタ",
  "block.minecraft.light_blue_terracotta": "空色のテラコッタ",
  "block.minecraft.yellow_terracotta": "黄色のテラコッタ",
  "block.minecraft.lime_terracotta": "黄緑色のテラコッタ",
  "block.minecraft.pink_terracotta": "桃色のテラコッタ",
  "block.minecraft.gray_terracotta": "灰色のテラコッタ",
  "block.minecraft.light_gray_terracotta": "薄灰色のテラコッタ",
  "block.minecraft.cyan_terracotta": "青緑色のテラコッタ",
  "block.minecraft.purple_terracotta": "紫色のテラコッタ",
  "block.minecraft.blue_terracotta": "青色のテラコッタ",
  "block.minecraft.brown_terracotta": "茶色のテラコッタ",
  "block.minecraft.green_terracotta": "緑色のテラコッタ",
  "block.minecraft.red_terracotta": "赤色のテラコッタ",
  "block.minecraft.black_terracotta": "黒色のテラコッタ",
  "block.minecraft.barrier": "バリアブロック",
  "block.minecraft.iron_trapdoor": "鉄のトラップドア",
  "block.minecraft.hay_block": "干草の俵",
  "block.minecraft.white_carpet": "白色のカーペット",
  "block.minecraft.orange_carpet": "橙色のカーペット",
  "block.minecraft.magenta_carpet": "赤紫色のカーペット",
  "block.minecraft.light_blue_carpet": "空色のカーペット",
  "block.minecraft.yellow_carpet": "黄色のカーペット",
  "block.minecraft.lime_carpet": "黄緑色のカーペット",
  "block.minecraft.pink_carpet": "桃色のカーペット",
  "block.minecraft.gray_carpet": "灰色のカーペット",
  "block.minecraft.light_gray_carpet": "薄灰色のカーペット",
  "block.minecraft.cyan_carpet": "青緑色のカーペット",
  "block.minecraft.purple_carpet": "紫色のカーペット",
  "block.minecraft.blue_carpet": "青色のカーペット",
  "block.minecraft.brown_carpet": "茶色のカーペット",
  "block.minecraft.green_carpet": "緑色のカーペット",
  "block.minecraft.red_carpet": "赤色のカーペット",
  "block.minecraft.black_carpet": "黒色のカーペット",
  "block.minecraft.terracotta": "テラコッタ",
  "block.minecraft.coal_block": "石炭ブロック",
  "block.minecraft.packed_ice": "氷塊",
  "block.minecraft.acacia_stairs": "アカシアの階段",
  "block.minecraft.dark_oak_stairs": "ダークオークの階段",
  "block.minecraft.slime_block": "スライムブロック",
  "block.minecraft.grass_path": "草の道",
  "block.minecraft.sunflower": "ヒマワリ",
  "block.minecraft.lilac": "ライラック",
  "block.minecraft.rose_bush": "バラの低木",
  "block.minecraft.peony": "ボタン",
  "block.minecraft.tall_grass": "背の高い草",
  "block.minecraft.large_fern": "大きなシダ",
  "block.minecraft.white_stained_glass": "白色の色付きガラス",
  "block.minecraft.orange_stained_glass": "橙色の色付きガラス",
  "block.minecraft.magenta_stained_glass": "赤紫色の色付きガラス",
  "block.minecraft.light_blue_stained_glass": "空色の色付きガラス",
  "block.minecraft.yellow_stained_glass": "黄色の色付きガラス",
  "block.minecraft.lime_stained_glass": "黄緑色の色付きガラス",
  "block.minecraft.pink_stained_glass": "桃色の色付きガラス",
  "block.minecraft.gray_stained_glass": "灰色の色付きガラス",
  "block.minecraft.light_gray_stained_glass": "薄灰色の色付きガラス",
  "block.minecraft.cyan_stained_glass": "青緑色の色付きガラス",
  "block.minecraft.purple_stained_glass": "紫色の色付きガラス",
  "block.minecraft.blue_stained_glass": "青色の色付きガラス",
  "block.minecraft.brown_stained_glass": "茶色の色付きガラス",
  "block.minecraft.green_stained_glass": "緑色の色付きガラス",
  "block.minecraft.red_stained_glass": "赤色の色付きガラス",
  "block.minecraft.black_stained_glass": "黒色の色付きガラス",
  "block.minecraft.white_stained_glass_pane": "白色の色付きガラス板",
  "block.minecraft.orange_stained_glass_pane": "橙色の色付きガラス板",
  "block.minecraft.magenta_stained_glass_pane": "赤紫色の色付きガラス板",
  "block.minecraft.light_blue_stained_glass_pane": "空色の色付きガラス板",
  "block.minecraft.yellow_stained_glass_pane": "黄色の色付きガラス板",
  "block.minecraft.lime_stained_glass_pane": "黄緑色の色付きガラス板",
  "block.minecraft.pink_stained_glass_pane": "桃色の色付きガラス板",
  "block.minecraft.gray_stained_glass_pane": "灰色の色付きガラス板",
  "block.minecraft.light_gray_stained_glass_pane": "薄灰色の色付きガラス板",
  "block.minecraft.cyan_stained_glass_pane": "青緑色の色付きガラス板",
  "block.minecraft.purple_stained_glass_pane": "紫色の色付きガラス板",
  "block.minecraft.blue_stained_glass_pane": "青色の色付きガラス板",
  "block.minecraft.brown_stained_glass_pane": "茶色の色付きガラス板",
  "block.minecraft.green_stained_glass_pane": "緑色の色付きガラス板",
  "block.minecraft.red_stained_glass_pane": "赤色の色付きガラス板",
  "block.minecraft.black_stained_glass_pane": "黒色の色付きガラス板",
  "block.minecraft.prismarine": "プリズマリン",
  "block.minecraft.prismarine_bricks": "プリズマリンレンガ",
  "block.minecraft.dark_prismarine": "ダークプリズマリン",
  "block.minecraft.prismarine_stairs": "プリズマリンの階段",
  "block.minecraft.prismarine_brick_stairs": "プリズマリンレンガの階段",
  "block.minecraft.dark_prismarine_stairs": "ダークプリズマリンの階段",
  "block.minecraft.sea_lantern": "シーランタン",
  "block.minecraft.red_sandstone": "赤い砂岩",
  "block.minecraft.chiseled_red_sandstone": "模様入りの赤い砂岩",
  "block.minecraft.cut_red_sandstone": "研がれた赤い砂岩",
  "block.minecraft.red_sandstone_stairs": "赤い砂岩の階段",
  "block.minecraft.repeating_command_block": "リピートコマンドブロック",
  "block.minecraft.chain_command_block": "チェーンコマンドブロック",
  "block.minecraft.magma_block": "マグマブロック",
  "block.minecraft.nether_wart_block": "ネザーウォートブロック",
  "block.minecraft.warped_wart_block": "歪んだウォートブロック",
  "block.minecraft.red_nether_bricks": "赤いネザーレンガ",
  "block.minecraft.bone_block": "骨ブロック",
  "block.minecraft.structure_void": "ストラクチャーヴォイド",
  "block.minecraft.observer": "オブザーバー",
  "block.minecraft.shulker_box": "シュルカーボックス",
  "block.minecraft.white_shulker_box": "白色のシュルカーボックス",
  "block.minecraft.orange_shulker_box": "橙色のシュルカーボックス",
  "block.minecraft.magenta_shulker_box": "赤紫色のシュルカーボックス",
  "block.minecraft.light_blue_shulker_box": "空色のシュルカーボックス",
  "block.minecraft.yellow_shulker_box": "黄色のシュルカーボックス",
  "block.minecraft.lime_shulker_box": "黄緑色のシュルカーボックス",
  "block.minecraft.pink_shulker_box": "桃色のシュルカーボックス",
  "block.minecraft.gray_shulker_box": "灰色のシュルカーボックス",
  "block.minecraft.light_gray_shulker_box": "薄灰色のシュルカーボックス",
  "block.minecraft.cyan_shulker_box": "青緑色のシュルカーボックス",
  "block.minecraft.purple_shulker_box": "紫色のシュルカーボックス",
  "block.minecraft.blue_shulker_box": "青色のシュルカーボックス",
  "block.minecraft.brown_shulker_box": "茶色のシュルカーボックス",
  "block.minecraft.green_shulker_box": "緑色のシュルカーボックス",
  "block.minecraft.red_shulker_box": "赤色のシュルカーボックス",
  "block.minecraft.black_shulker_box": "黒色のシュルカーボックス",
  "block.minecraft.white_glazed_terracotta": "白色の彩釉テラコッタ",
  "block.minecraft.orange_glazed_terracotta": "橙色の彩釉テラコッタ",
  "block.minecraft.magenta_glazed_terracotta": "赤紫色の彩釉テラコッタ",
  "block.minecraft.light_blue_glazed_terracotta": "空色の彩釉テラコッタ",
  "block.minecraft.yellow_glazed_terracotta": "黄色の彩釉テラコッタ",
  "block.minecraft.lime_glazed_terracotta": "黄緑色の彩釉テラコッタ",
  "block.minecraft.pink_glazed_terracotta": "桃色の彩釉テラコッタ",
  "block.minecraft.gray_glazed_terracotta": "灰色の彩釉テラコッタ",
  "block.minecraft.light_gray_glazed_terracotta": "薄灰色の彩釉テラコッタ",
  "block.minecraft.cyan_glazed_terracotta": "青緑色の彩釉テラコッタ",
  "block.minecraft.purple_glazed_terracotta": "紫色の彩釉テラコッタ",
  "block.minecraft.blue_glazed_terracotta": "青色の彩釉テラコッタ",
  "block.minecraft.brown_glazed_terracotta": "茶色の彩釉テラコッタ",
  "block.minecraft.green_glazed_terracotta": "緑色の彩釉テラコッタ",
  "block.minecraft.red_glazed_terracotta": "赤色の彩釉テラコッタ",
  "block.minecraft.black_glazed_terracotta": "黒色の彩釉テラコッタ",
  "block.minecraft.white_concrete": "白色のコンクリート",
  "block.minecraft.orange_concrete": "橙色のコンクリート",
  "block.minecraft.magenta_concrete": "赤紫色のコンクリート",
  "block.minecraft.light_blue_concrete": "空色のコンクリート",
  "block.minecraft.yellow_concrete": "黄色のコンクリート",
  "block.minecraft.lime_concrete": "黄緑色のコンクリート",
  "block.minecraft.pink_concrete": "桃色のコンクリート",
  "block.minecraft.gray_concrete": "灰色のコンクリート",
  "block.minecraft.light_gray_concrete": "薄灰色のコンクリート",
  "block.minecraft.cyan_concrete": "青緑色のコンクリート",
  "block.minecraft.purple_concrete": "紫色のコンクリート",
  "block.minecraft.blue_concrete": "青色のコンクリート",
  "block.minecraft.brown_concrete": "茶色のコンクリート",
  "block.minecraft.green_concrete": "緑色のコンクリート",
  "block.minecraft.red_concrete": "赤色のコンクリート",
  "block.minecraft.black_concrete": "黒色のコンクリート",
  "block.minecraft.white_concrete_powder": "白色のコンクリートパウダー",
  "block.minecraft.orange_concrete_powder": "橙色のコンクリートパウダー",
  "block.minecraft.magenta_concrete_powder": "赤紫色のコンクリートパウダー",
  "block.minecraft.light_blue_concrete_powder": "空色のコンクリートパウダー",
  "block.minecraft.yellow_concrete_powder": "黄色のコンクリートパウダー",
  "block.minecraft.lime_concrete_powder": "黄緑色のコンクリートパウダー",
  "block.minecraft.pink_concrete_powder": "桃色のコンクリートパウダー",
  "block.minecraft.gray_concrete_powder": "灰色のコンクリートパウダー",
  "block.minecraft.light_gray_concrete_powder": "薄灰色のコンクリートパウダー",
  "block.minecraft.cyan_concrete_powder": "青緑色のコンクリートパウダー",
  "block.minecraft.purple_concrete_powder": "紫色のコンクリートパウダー",
  "block.minecraft.blue_concrete_powder": "青色のコンクリートパウダー",
  "block.minecraft.brown_concrete_powder": "茶色のコンクリートパウダー",
  "block.minecraft.green_concrete_powder": "緑色のコンクリートパウダー",
  "block.minecraft.red_concrete_powder": "赤色のコンクリートパウダー",
  "block.minecraft.black_concrete_powder": "黒色のコンクリートパウダー",
  "block.minecraft.turtle_egg": "カメの卵",
  "block.minecraft.dead_tube_coral_block": "死んだクダサンゴブロック",
  "block.minecraft.dead_brain_coral_block": "死んだノウサンゴブロック",
  "block.minecraft.dead_bubble_coral_block": "死んだミズタマサンゴブロック",
  "block.minecraft.dead_fire_coral_block": "死んだミレポラサンゴブロック",
  "block.minecraft.dead_horn_coral_block": "死んだシカツノサンゴブロック",
  "block.minecraft.tube_coral_block": "クダサンゴブロック",
  "block.minecraft.brain_coral_block": "ノウサンゴブロック",
  "block.minecraft.bubble_coral_block": "ミズタマサンゴブロック",
  "block.minecraft.fire_coral_block": "ミレポラサンゴブロック",
  "block.minecraft.horn_coral_block": "シカツノサンゴブロック",
  "block.minecraft.tube_coral": "クダサンゴ",
  "block.minecraft.brain_coral": "ノウサンゴ",
  "block.minecraft.bubble_coral": "ミズタマサンゴ",
  "block.minecraft.fire_coral": "ミレポラサンゴ",
  "block.minecraft.horn_coral": "シカツノサンゴ",
  "block.minecraft.dead_brain_coral": "死んだノウサンゴ",
  "block.minecraft.dead_bubble_coral": "死んだミズタマサンゴ",
  "block.minecraft.dead_fire_coral": "死んだミレポラサンゴ",
  "block.minecraft.dead_horn_coral": "死んだシカツノサンゴ",
  "block.minecraft.dead_tube_coral": "死んだクダサンゴ",
  "block.minecraft.tube_coral_fan": "クダウチワサンゴ",
  "block.minecraft.brain_coral_fan": "ノウウチワサンゴ",
  "block.minecraft.bubble_coral_fan": "ミズタマウチワサンゴ",
  "block.minecraft.fire_coral_fan": "ミレポラウチワサンゴ",
  "block.minecraft.horn_coral_fan": "シカツノウチワサンゴ",
  "block.minecraft.dead_tube_coral_fan": "死んだクダウチワサンゴ",
  "block.minecraft.dead_brain_coral_fan": "死んだノウウチワサンゴ",
  "block.minecraft.dead_bubble_coral_fan": "死んだミズタマウチワサンゴ",
  "block.minecraft.dead_fire_coral_fan": "死んだミレポラウチワサンゴ",
  "block.minecraft.dead_horn_coral_fan": "死んだシカツノウチワサンゴ",
  "block.minecraft.blue_ice": "青氷",
  "block.minecraft.conduit": "コンジット",
  "block.minecraft.polished_granite_stairs": "磨かれた花崗岩の階段",
  "block.minecraft.smooth_red_sandstone_stairs": "滑らかな赤い砂岩の階段",
  "block.minecraft.mossy_stone_brick_stairs": "苔むした石レンガの階段",
  "block.minecraft.polished_diorite_stairs": "磨かれた閃緑岩の階段",
  "block.minecraft.mossy_cobblestone_stairs": "苔むした丸石の階段",
  "block.minecraft.end_stone_brick_stairs": "エンドストーンレンガの階段",
  "block.minecraft.stone_stairs": "石の階段",
  "block.minecraft.smooth_sandstone_stairs": "滑らかな砂岩の階段",
  "block.minecraft.smooth_quartz_stairs": "滑らかなクォーツの階段",
  "block.minecraft.granite_stairs": "花崗岩の階段",
  "block.minecraft.andesite_stairs": "安山岩の階段",
  "block.minecraft.red_nether_brick_stairs": "赤いネザーレンガの階段",
  "block.minecraft.polished_andesite_stairs": "磨かれた安山岩の階段",
  "block.minecraft.diorite_stairs": "閃緑岩の階段",
  "block.minecraft.polished_granite_slab": "磨かれた花崗岩のハーフブロック",
  "block.minecraft.smooth_red_sandstone_slab": "滑らかな赤い砂岩のハーフブロック",
  "block.minecraft.mossy_stone_brick_slab": "苔むした石レンガのハーフブロック",
  "block.minecraft.polished_diorite_slab": "磨かれた閃緑岩のハーフブロック",
  "block.minecraft.mossy_cobblestone_slab": "苔むした丸石のハーフブロック",
  "block.minecraft.end_stone_brick_slab": "エンドストーンレンガのハーフブロック",
  "block.minecraft.smooth_sandstone_slab": "滑らかな砂岩のハーフブロック",
  "block.minecraft.smooth_quartz_slab": "滑らかなクォーツのハーフブロック",
  "block.minecraft.granite_slab": "花崗岩のハーフブロック",
  "block.minecraft.andesite_slab": "安山岩のハーフブロック",
  "block.minecraft.red_nether_brick_slab": "赤いネザーレンガのハーフブロック",
  "block.minecraft.polished_andesite_slab": "磨かれた安山岩のハーフブロック",
  "block.minecraft.diorite_slab": "閃緑岩のハーフブロック",
  "block.minecraft.scaffolding": "足場",
  "block.minecraft.iron_door": "鉄のドア",
  "block.minecraft.oak_door": "オークのドア",
  "block.minecraft.spruce_door": "トウヒのドア",
  "block.minecraft.birch_door": "シラカバのドア",
  "block.minecraft.jungle_door": "ジャングルのドア",
  "block.minecraft.acacia_door": "アカシアのドア",
  "block.minecraft.dark_oak_door": "ダークオークのドア",
  "block.minecraft.crimson_door": "真紅のドア",
  "block.minecraft.warped_door": "歪んだドア",
  "block.minecraft.repeater": "レッドストーンリピーター",
  "block.minecraft.comparator": "レッドストーンコンパレーター",
  "block.minecraft.structure_block": "ストラクチャーブロック",
  "block.minecraft.jigsaw": "ジグソーブロック",
  "item.minecraft.turtle_helmet": "カメの甲羅□□頭に装備したとき：□防具 +2",
  "item.minecraft.scute": "カメのウロコ",
  "item.minecraft.iron_shovel": "鉄のシャベル□□利き手に持ったとき：□攻撃力 +3.5□攻撃速度 -3",
  "item.minecraft.iron_pickaxe": "鉄のツルハシ□□利き手に持ったとき：□攻撃力 +3□攻撃速度 -2.8",
  "item.minecraft.iron_axe": "鉄の斧□□利き手に持ったとき：□攻撃力 +8□攻撃速度 -3.1",
  "item.minecraft.flint_and_steel": "火打石と打ち金",
  "item.minecraft.apple": "リンゴ",
  "item.minecraft.bow": "弓",
  "item.minecraft.arrow": "矢",
  "item.minecraft.coal": "石炭",
  "item.minecraft.charcoal": "木炭",
  "item.minecraft.diamond": "ダイヤモンド",
  "item.minecraft.iron_ingot": "鉄インゴット",
  "item.minecraft.gold_ingot": "金インゴット",
  "item.minecraft.netherite_ingot": "ネザライトインゴット",
  "item.minecraft.netherite_scrap": "ネザライトの欠片",
  "item.minecraft.iron_sword": "鉄の剣□□利き手に持ったとき：□攻撃力 +5□攻撃速度 -2.4",
  "item.minecraft.wooden_sword": "木の剣□□利き手に持ったとき：□攻撃力 +3□攻撃速度 -2.4",
  "item.minecraft.wooden_shovel": "木のシャベル□□利き手に持ったとき：□攻撃力 +1.5□攻撃速度 -3",
  "item.minecraft.wooden_pickaxe": "木のツルハシ□□利き手に持ったとき：□攻撃力 +1□攻撃速度 -2.8",
  "item.minecraft.wooden_axe": "木の斧□□利き手に持ったとき：□攻撃力 +6□攻撃速度 -3.2",
  "item.minecraft.stone_sword": "石の剣□□利き手に持ったとき：□攻撃力 +4□攻撃速度 -2.4",
  "item.minecraft.stone_shovel": "石のシャベル□□利き手に持ったとき：□攻撃力 +2.5□攻撃速度 -3",
  "item.minecraft.stone_pickaxe": "石のツルハシ□□利き手に持ったとき：□攻撃力 +2□攻撃速度 -2.8",
  "item.minecraft.stone_axe": "石の斧□□利き手に持ったとき：□攻撃力 +8□攻撃速度 -3.2",
  "item.minecraft.diamond_sword": "ダイヤモンドの剣□□利き手に持ったとき：□攻撃力 +6□攻撃速度 -2.4",
  "item.minecraft.diamond_shovel": "ダイヤモンドのシャベル□□利き手に持ったとき：□攻撃力 +4.5□攻撃速度 -3",
  "item.minecraft.diamond_pickaxe": "ダイヤモンドのツルハシ□□利き手に持ったとき：□攻撃力 +4□攻撃速度 -2.8",
  "item.minecraft.diamond_axe": "ダイヤモンドの斧□□利き手に持ったとき：□攻撃力 +8□攻撃速度 -3",
  "item.minecraft.stick": "棒",
  "item.minecraft.bowl": "ボウル",
  "item.minecraft.mushroom_stew": "キノコシチュー",
  "item.minecraft.golden_sword": "金の剣□□利き手に持ったとき：□攻撃力 +3□攻撃速度 -2.4",
  "item.minecraft.golden_shovel": "金のシャベル□□利き手に持ったとき：□攻撃力 +1.5□攻撃速度 -3",
  "item.minecraft.golden_pickaxe": "金のツルハシ□□利き手に持ったとき：□攻撃力 +1□攻撃速度 -2.8",
  "item.minecraft.golden_axe": "金の斧□□利き手に持ったとき：□攻撃力 +6□攻撃速度 -3",
  "item.minecraft.netherite_sword": "ネザライトの剣□□利き手に持ったとき：□攻撃力 +7□攻撃速度 -2.4",
  "item.minecraft.netherite_shovel": "ネザライトのシャベル□□利き手に持ったとき：□攻撃力 +5.5□攻撃速度 -3",
  "item.minecraft.netherite_pickaxe": "ネザライトのツルハシ□□利き手に持ったとき：□攻撃力 +5□攻撃速度 -2.8",
  "item.minecraft.netherite_axe": "ネザライトの斧□□利き手に持ったとき：□攻撃力 +9□攻撃速度 -3",
  "item.minecraft.string": "糸",
  "item.minecraft.feather": "羽根",
  "item.minecraft.gunpowder": "火薬",
  "item.minecraft.wooden_hoe": "木のクワ□□利き手に持ったとき：□攻撃速度 -3",
  "item.minecraft.stone_hoe": "石のクワ□□利き手に持ったとき：□攻撃速度 -2",
  "item.minecraft.iron_hoe": "鉄のクワ□□利き手に持ったとき：□攻撃速度 -1",
  "item.minecraft.diamond_hoe": "ダイヤモンドのクワ□□利き手に持ったとき：",
  "item.minecraft.golden_hoe": "金のクワ□□利き手に持ったとき：□攻撃速度 -3",
  "item.minecraft.netherite_hoe": "ネザライトのクワ□□利き手に持ったとき：",
  "item.minecraft.wheat_seeds": "小麦の種",
  "item.minecraft.wheat": "小麦",
  "item.minecraft.bread": "パン",
  "item.minecraft.leather_helmet": "革の帽子□□頭に装備したとき：□防具 +1",
  "item.minecraft.leather_chestplate": "革の上着□□胴体に装備したとき：□防具 +3",
  "item.minecraft.leather_leggings": "革のズボン□□脚に装備したとき：□防具 +2",
  "item.minecraft.leather_boots": "革のブーツ□□足に装備したとき：□防具 +1",
  "item.minecraft.chainmail_helmet": "チェーンのヘルメット□□頭に装備したとき：□防具 +2",
  "item.minecraft.chainmail_chestplate": "チェーンのチェストプレート□□胴体に装備したとき：□防具 +5",
  "item.minecraft.chainmail_leggings": "チェーンのレギンス□□脚に装備したとき：□防具 +4",
  "item.minecraft.chainmail_boots": "チェーンのブーツ□□足に装備したとき：□防具 +1",
  "item.minecraft.iron_helmet": "鉄のヘルメット□□頭に装備したとき：□防具 +2",
  "item.minecraft.iron_chestplate": "鉄のチェストプレート□□胴体に装備したとき：□防具 +6",
  "item.minecraft.iron_leggings": "鉄のレギンス□□脚に装備したとき：□防具 +5",
  "item.minecraft.iron_boots": "鉄のブーツ□□足に装備したとき：□防具 +2",
  "item.minecraft.diamond_helmet": "ダイヤモンドのヘルメット□□頭に装備したとき：□防具 +3□防具強度 +2",
  "item.minecraft.diamond_chestplate": "ダイヤモンドのチェストプレート□□胴体に装備したとき：□防具 +8□防具強度 +2",
  "item.minecraft.diamond_leggings": "ダイヤモンドのレギンス□□脚に装備したとき：□防具 +6□防具強度 +2",
  "item.minecraft.diamond_boots": "ダイヤモンドのブーツ□□足に装備したとき：□防具 +3□防具強度 +2",
  "item.minecraft.golden_helmet": "金のヘルメット□□頭に装備したとき：□防具 +2",
  "item.minecraft.golden_chestplate": "金のチェストプレート□□胴体に装備したとき：□防具 +5",
  "item.minecraft.golden_leggings": "金のレギンス□□脚に装備したとき：□防具 +3",
  "item.minecraft.golden_boots": "金のブーツ□□足に装備したとき：□防具 +1",
  "item.minecraft.netherite_helmet": "ネザライトのヘルメット□□頭に装備したとき：□防具 +3□防具強度 +3□ノックバック耐性 +1",
  "item.minecraft.netherite_chestplate": "ネザライトのチェストプレート□□胴体に装備したとき：□防具 +8□防具強度 +3□ノックバック耐性 +1",
  "item.minecraft.netherite_leggings": "ネザライトのレギンス□□脚に装備したとき：□防具 +6□防具強度 +3□ノックバック耐性 +1",
  "item.minecraft.netherite_boots": "ネザライトのブーツ□□足に装備したとき：□防具 +3□防具強度 +3□ノックバック耐性 +1",
  "item.minecraft.flint": "火打石",
  "item.minecraft.porkchop": "生の豚肉",
  "item.minecraft.cooked_porkchop": "焼き豚",
  "item.minecraft.painting": "絵画",
  "item.minecraft.golden_apple": "金のリンゴ",
  "item.minecraft.enchanted_golden_apple": "エンチャントされた金のリンゴ",
  "block.minecraft.oak_sign": "オークの看板",
  "block.minecraft.spruce_sign": "トウヒの看板",
  "block.minecraft.birch_sign": "シラカバの看板",
  "block.minecraft.jungle_sign": "ジャングルの看板",
  "block.minecraft.acacia_sign": "アカシアの看板",
  "block.minecraft.dark_oak_sign": "ダークオークの看板",
  "block.minecraft.crimson_sign": "真紅の看板",
  "block.minecraft.warped_sign": "歪んだ看板",
  "item.minecraft.bucket": "バケツ",
  "item.minecraft.water_bucket": "水入りバケツ",
  "item.minecraft.lava_bucket": "溶岩入りバケツ",
  "item.minecraft.minecart": "トロッコ",
  "item.minecraft.saddle": "鞍",
  "item.minecraft.redstone": "レッドストーンダスト",
  "item.minecraft.snowball": "雪玉",
  "item.minecraft.oak_boat": "オークのボート",
  "item.minecraft.leather": "革",
  "item.minecraft.milk_bucket": "ミルク入りバケツ",
  "item.minecraft.pufferfish_bucket": "フグ入りバケツ",
  "item.minecraft.salmon_bucket": "サケ入りバケツ",
  "item.minecraft.cod_bucket": "タラ入りバケツ",
  "item.minecraft.tropical_fish_bucket": "熱帯魚入りバケツ",
  "item.minecraft.brick": "レンガ",
  "item.minecraft.clay_ball": "粘土玉",
  "block.minecraft.dried_kelp_block": "乾燥した昆布ブロック",
  "item.minecraft.paper": "紙",
  "item.minecraft.book": "本",
  "item.minecraft.slime_ball": "スライムボール",
  "item.minecraft.chest_minecart": "チェスト付きトロッコ",
  "item.minecraft.furnace_minecart": "かまど付きトロッコ",
  "item.minecraft.egg": "卵",
  "item.minecraft.compass": "コンパス",
  "item.minecraft.fishing_rod": "釣竿",
  "item.minecraft.clock": "時計",
  "item.minecraft.glowstone_dust": "グロウストーンダスト",
  "item.minecraft.cod": "生鱈",
  "item.minecraft.salmon": "生鮭",
  "item.minecraft.tropical_fish": "熱帯魚",
  "item.minecraft.pufferfish": "フグ",
  "item.minecraft.cooked_cod": "焼き鱈",
  "item.minecraft.cooked_salmon": "焼き鮭",
  "item.minecraft.ink_sac": "イカスミ",
  "item.minecraft.red_dye": "赤色の染料",
  "item.minecraft.green_dye": "緑色の染料",
  "item.minecraft.cocoa_beans": "カカオ豆",
  "item.minecraft.lapis_lazuli": "ラピスラズリ",
  "item.minecraft.purple_dye": "紫色の染料",
  "item.minecraft.cyan_dye": "青緑色の染料",
  "item.minecraft.light_gray_dye": "薄灰色の染料",
  "item.minecraft.gray_dye": "灰色の染料",
  "item.minecraft.pink_dye": "桃色の染料",
  "item.minecraft.lime_dye": "黄緑色の染料",
  "item.minecraft.yellow_dye": "黄色の染料",
  "item.minecraft.light_blue_dye": "空色の染料",
  "item.minecraft.magenta_dye": "赤紫色の染料",
  "item.minecraft.orange_dye": "橙色の染料",
  "item.minecraft.bone_meal": "骨粉",
  "item.minecraft.blue_dye": "青色の染料",
  "item.minecraft.brown_dye": "茶色の染料",
  "item.minecraft.black_dye": "黒色の染料",
  "item.minecraft.white_dye": "白色の染料",
  "item.minecraft.bone": "骨",
  "item.minecraft.sugar": "砂糖",
  "block.minecraft.cake": "ケーキ",
  "block.minecraft.white_bed": "白色のベッド",
  "block.minecraft.orange_bed": "橙色のベッド",
  "block.minecraft.magenta_bed": "赤紫色のベッド",
  "block.minecraft.light_blue_bed": "空色のベッド",
  "block.minecraft.yellow_bed": "黄色のベッド",
  "block.minecraft.lime_bed": "黄緑色のベッド",
  "block.minecraft.pink_bed": "桃色のベッド",
  "block.minecraft.gray_bed": "灰色のベッド",
  "block.minecraft.light_gray_bed": "薄灰色のベッド",
  "block.minecraft.cyan_bed": "青緑色のベッド",
  "block.minecraft.purple_bed": "紫色のベッド",
  "block.minecraft.blue_bed": "青色のベッド",
  "block.minecraft.brown_bed": "茶色のベッド",
  "block.minecraft.green_bed": "緑色のベッド",
  "block.minecraft.red_bed": "赤色のベッド",
  "block.minecraft.black_bed": "黒色のベッド",
  "item.minecraft.cookie": "クッキー",
  "item.minecraft.filled_map": "地図□#0",
  "item.minecraft.shears": "ハサミ",
  "item.minecraft.melon_slice": "スイカの薄切り",
  "item.minecraft.dried_kelp": "乾燥した昆布",
  "item.minecraft.pumpkin_seeds": "カボチャの種",
  "item.minecraft.melon_seeds": "スイカの種",
  "item.minecraft.beef": "生の牛肉",
  "item.minecraft.cooked_beef": "ステーキ",
  "item.minecraft.chicken": "生の鶏肉",
  "item.minecraft.cooked_chicken": "焼き鳥",
  "item.minecraft.rotten_flesh": "腐った肉",
  "item.minecraft.ender_pearl": "エンダーパール",
  "item.minecraft.blaze_rod": "ブレイズロッド",
  "item.minecraft.ghast_tear": "ガストの涙",
  "item.minecraft.gold_nugget": "金塊",
  "item.minecraft.nether_wart": "ネザーウォート",
  "item.minecraft.potion": "クラフト不可能なポーション□効果なし",
  "item.minecraft.glass_bottle": "ガラス瓶",
  "item.minecraft.spider_eye": "クモの目",
  "item.minecraft.fermented_spider_eye": "発酵したクモの目",
  "item.minecraft.blaze_powder": "ブレイズパウダー",
  "item.minecraft.magma_cream": "マグマクリーム",
  "block.minecraft.brewing_stand": "醸造台",
  "block.minecraft.cauldron": "大釜",
  "item.minecraft.ender_eye": "エンダーアイ",
  "item.minecraft.glistering_melon_slice": "きらめくスイカの薄切り",
  "item.minecraft.bat_spawn_egg": "コウモリのスポーンエッグ",
  "item.minecraft.bee_spawn_egg": "ミツバチのスポーンエッグ",
  "item.minecraft.blaze_spawn_egg": "ブレイズのスポーンエッグ",
  "item.minecraft.cat_spawn_egg": "ネコのスポーンエッグ",
  "item.minecraft.cave_spider_spawn_egg": "洞窟グモのスポーンエッグ",
  "item.minecraft.chicken_spawn_egg": "ニワトリのスポーンエッグ",
  "item.minecraft.cod_spawn_egg": "タラのスポーンエッグ",
  "item.minecraft.cow_spawn_egg": "ウシのスポーンエッグ",
  "item.minecraft.creeper_spawn_egg": "クリーパーのスポーンエッグ",
  "item.minecraft.dolphin_spawn_egg": "イルカのスポーンエッグ",
  "item.minecraft.donkey_spawn_egg": "ロバのスポーンエッグ",
  "item.minecraft.drowned_spawn_egg": "ドラウンドのスポーンエッグ",
  "item.minecraft.elder_guardian_spawn_egg": "エルダーガーディアンのスポーンエッグ",
  "item.minecraft.enderman_spawn_egg": "エンダーマンのスポーンエッグ",
  "item.minecraft.endermite_spawn_egg": "エンダーマイトのスポーンエッグ",
  "item.minecraft.evoker_spawn_egg": "エヴォーカーのスポーンエッグ",
  "item.minecraft.fox_spawn_egg": "キツネのスポーンエッグ",
  "item.minecraft.ghast_spawn_egg": "ガストのスポーンエッグ",
  "item.minecraft.guardian_spawn_egg": "ガーディアンのスポーンエッグ",
  "item.minecraft.hoglin_spawn_egg": "ホグリンのスポーンエッグ",
  "item.minecraft.horse_spawn_egg": "ウマのスポーンエッグ",
  "item.minecraft.husk_spawn_egg": "ハスクのスポーンエッグ",
  "item.minecraft.llama_spawn_egg": "ラマのスポーンエッグ",
  "item.minecraft.magma_cube_spawn_egg": "マグマキューブのスポーンエッグ",
  "item.minecraft.mooshroom_spawn_egg": "ムーシュルームのスポーンエッグ",
  "item.minecraft.mule_spawn_egg": "ラバのスポーンエッグ",
  "item.minecraft.ocelot_spawn_egg": "ヤマネコのスポーンエッグ",
  "item.minecraft.panda_spawn_egg": "パンダのスポーンエッグ",
  "item.minecraft.parrot_spawn_egg": "オウムのスポーンエッグ",
  "item.minecraft.phantom_spawn_egg": "ファントムのスポーンエッグ",
  "item.minecraft.pig_spawn_egg": "ブタのスポーンエッグ",
  "item.minecraft.piglin_spawn_egg": "ピグリンのスポーンエッグ",
  "item.minecraft.pillager_spawn_egg": "ピリジャーのスポーンエッグ",
  "item.minecraft.polar_bear_spawn_egg": "シロクマのスポーンエッグ",
  "item.minecraft.pufferfish_spawn_egg": "フグのスポーンエッグ",
  "item.minecraft.rabbit_spawn_egg": "ウサギのスポーンエッグ",
  "item.minecraft.ravager_spawn_egg": "ラヴェジャーのスポーンエッグ",
  "item.minecraft.salmon_spawn_egg": "サケのスポーンエッグ",
  "item.minecraft.sheep_spawn_egg": "ヒツジのスポーンエッグ",
  "item.minecraft.shulker_spawn_egg": "シュルカーのスポーンエッグ",
  "item.minecraft.silverfish_spawn_egg": "シルバーフィッシュのスポーンエッグ",
  "item.minecraft.skeleton_spawn_egg": "スケルトンのスポーンエッグ",
  "item.minecraft.skeleton_horse_spawn_egg": "スケルトンホースのスポーンエッグ",
  "item.minecraft.slime_spawn_egg": "スライムのスポーンエッグ",
  "item.minecraft.spider_spawn_egg": "クモのスポーンエッグ",
  "item.minecraft.squid_spawn_egg": "イカのスポーンエッグ",
  "item.minecraft.stray_spawn_egg": "ストレイのスポーンエッグ",
  "item.minecraft.strider_spawn_egg": "ストライダーのスポーンエッグ",
  "item.minecraft.trader_llama_spawn_egg": "商人のラマのスポーンエッグ",
  "item.minecraft.tropical_fish_spawn_egg": "熱帯魚のスポーンエッグ",
  "item.minecraft.turtle_spawn_egg": "カメのスポーンエッグ",
  "item.minecraft.vex_spawn_egg": "ヴェックスのスポーンエッグ",
  "item.minecraft.villager_spawn_egg": "村人のスポーンエッグ",
  "item.minecraft.vindicator_spawn_egg": "ヴィンディケーターのスポーンエッグ",
  "item.minecraft.wandering_trader_spawn_egg": "行商人のスポーンエッグ",
  "item.minecraft.witch_spawn_egg": "ウィッチのスポーンエッグ",
  "item.minecraft.wither_skeleton_spawn_egg": "ウィザースケルトンのスポーンエッグ",
  "item.minecraft.wolf_spawn_egg": "オオカミのスポーンエッグ",
  "item.minecraft.zoglin_spawn_egg": "ゾグリンのスポーンエッグ",
  "item.minecraft.zombie_spawn_egg": "ゾンビのスポーンエッグ",
  "item.minecraft.zombie_horse_spawn_egg": "ゾンビホースのスポーンエッグ",
  "item.minecraft.zombie_villager_spawn_egg": "村人ゾンビのスポーンエッグ",
  "item.minecraft.zombified_piglin_spawn_egg": "ゾンビピグリンのスポーンエッグ",
  "item.minecraft.experience_bottle": "エンチャントの瓶",
  "item.minecraft.fire_charge": "ファイヤーチャージ",
  "item.minecraft.writable_book": "本と羽根ペン",
  "item.minecraft.written_book": "記入済みの本",
  "item.minecraft.emerald": "エメラルド",
  "item.minecraft.item_frame": "額縁",
  "block.minecraft.flower_pot": "植木鉢",
  "item.minecraft.carrot": "ニンジン",
  "item.minecraft.potato": "ジャガイモ",
  "item.minecraft.baked_potato": "ベイクドポテト",
  "item.minecraft.poisonous_potato": "青くなったジャガイモ",
  "item.minecraft.map": "白紙の地図",
  "item.minecraft.golden_carrot": "金のニンジン",
  "block.minecraft.skeleton_skull": "スケルトンの頭蓋骨",
  "block.minecraft.wither_skeleton_skull": "ウィザースケルトンの頭蓋骨",
  "block.minecraft.player_head": "プレイヤーの頭",
  "block.minecraft.zombie_head": "ゾンビの頭",
  "block.minecraft.creeper_head": "クリーパーの頭",
  "block.minecraft.dragon_head": "ドラゴンの頭",
  "item.minecraft.carrot_on_a_stick": "ニンジン付きの棒",
  "item.minecraft.warped_fungus_on_a_stick": "歪んだキノコ付きの棒",
  "item.minecraft.nether_star": "ネザースター",
  "item.minecraft.pumpkin_pie": "パンプキンパイ",
  "item.minecraft.firework_rocket": "ロケット花火",
  "item.minecraft.firework_star": "花火の星",
  "item.minecraft.enchanted_book": "エンチャントの本",
  "item.minecraft.nether_brick": "ネザーレンガ",
  "item.minecraft.quartz": "ネザークォーツ",
  "item.minecraft.tnt_minecart": "tnt付きトロッコ",
  "item.minecraft.hopper_minecart": "ホッパー付きトロッコ",
  "item.minecraft.prismarine_shard": "プリズマリンの欠片",
  "item.minecraft.prismarine_crystals": "プリズマリンクリスタル",
  "item.minecraft.rabbit": "生の兎肉",
  "item.minecraft.cooked_rabbit": "焼き兎肉",
  "item.minecraft.rabbit_stew": "ウサギシチュー",
  "item.minecraft.rabbit_foot": "ウサギの足",
  "item.minecraft.rabbit_hide": "ウサギの皮",
  "item.minecraft.armor_stand": "防具立て",
  "item.minecraft.iron_horse_armor": "鉄の馬鎧",
  "item.minecraft.golden_horse_armor": "金の馬鎧",
  "item.minecraft.diamond_horse_armor": "ダイヤモンドの馬鎧",
  "item.minecraft.leather_horse_armor": "革の馬鎧",
  "item.minecraft.lead": "リード",
  "item.minecraft.name_tag": "名札",
  "item.minecraft.command_block_minecart": "コマンドブロック付きトロッコ",
  "item.minecraft.mutton": "生の羊肉",
  "item.minecraft.cooked_mutton": "焼き羊肉",
  "block.minecraft.white_banner": "白色の旗",
  "block.minecraft.orange_banner": "橙色の旗",
  "block.minecraft.magenta_banner": "赤紫色の旗",
  "block.minecraft.light_blue_banner": "空色の旗",
  "block.minecraft.yellow_banner": "黄色の旗",
  "block.minecraft.lime_banner": "黄緑色の旗",
  "block.minecraft.pink_banner": "桃色の旗",
  "block.minecraft.gray_banner": "灰色の旗",
  "block.minecraft.light_gray_banner": "薄灰色の旗",
  "block.minecraft.cyan_banner": "青緑色の旗",
  "block.minecraft.purple_banner": "紫色の旗",
  "block.minecraft.blue_banner": "青色の旗",
  "block.minecraft.brown_banner": "茶色の旗",
  "block.minecraft.green_banner": "緑色の旗",
  "block.minecraft.red_banner": "赤色の旗",
  "block.minecraft.black_banner": "黒色の旗",
  "item.minecraft.end_crystal": "エンドクリスタル",
  "item.minecraft.chorus_fruit": "コーラスフルーツ",
  "item.minecraft.popped_chorus_fruit": "焼いたコーラスフルーツ",
  "item.minecraft.beetroot": "ビートルート",
  "item.minecraft.beetroot_seeds": "ビートルートの種",
  "item.minecraft.beetroot_soup": "ビートルートスープ",
  "item.minecraft.dragon_breath": "ドラゴンブレス",
  "item.minecraft.splash_potion": "クラフト不可能なスプラッシュポーション□効果なし",
  "item.minecraft.spectral_arrow": "光の矢",
  "item.minecraft.tipped_arrow": "クラフト不可能な効能付きの矢□効果なし",
  "item.minecraft.lingering_potion": "クラフト不可能な残留ポーション□効果なし",
  "item.minecraft.shield": "盾",
  "item.minecraft.elytra": "エリトラ",
  "item.minecraft.spruce_boat": "トウヒのボート",
  "item.minecraft.birch_boat": "シラカバのボート",
  "item.minecraft.jungle_boat": "ジャングルのボート",
  "item.minecraft.acacia_boat": "アカシアのボート",
  "item.minecraft.dark_oak_boat": "ダークオークのボート",
  "item.minecraft.totem_of_undying": "不死のトーテム",
  "item.minecraft.shulker_shell": "シュルカーの殻",
  "item.minecraft.iron_nugget": "鉄塊",
  "item.minecraft.knowledge_book": "知恵の本",
  "item.minecraft.debug_stick": "デバッグ棒",
  "item.minecraft.music_disc_13": "レコード□c418 - 13",
  "item.minecraft.music_disc_cat": "レコード□c418 - cat",
  "item.minecraft.music_disc_blocks": "レコード□c418 - blocks",
  "item.minecraft.music_disc_chirp": "レコード□c418 - chirp",
  "item.minecraft.music_disc_far": "レコード□c418 - far",
  "item.minecraft.music_disc_mall": "レコード□c418 - mall",
  "item.minecraft.music_disc_mellohi": "レコード□c418 - mellohi",
  "item.minecraft.music_disc_stal": "レコード□c418 - stal",
  "item.minecraft.music_disc_strad": "レコード□c418 - strad",
  "item.minecraft.music_disc_ward": "レコード□c418 - ward",
  "item.minecraft.music_disc_11": "レコード□c418 - 11",
  "item.minecraft.music_disc_wait": "レコード□c418 - wait",
  "item.minecraft.music_disc_pigstep": "レコード□レナ・レーン - pigstep",
  "item.minecraft.trident": "トライデント□□利き手に持ったとき：□攻撃力 +8□攻撃速度 -2.9",
  "item.minecraft.phantom_membrane": "ファントムの皮膜",
  "item.minecraft.nautilus_shell": "オウムガイの殻",
  "item.minecraft.heart_of_the_sea": "海洋の心",
  "item.minecraft.crossbow": "クロスボウ",
  "item.minecraft.suspicious_stew": "怪しげなシチュー",
  "block.minecraft.loom": "機織り機",
  "item.minecraft.flower_banner_pattern": "旗の模様□花模様",
  "item.minecraft.creeper_banner_pattern": "旗の模様□クリーパー模様",
  "item.minecraft.skull_banner_pattern": "旗の模様□骸骨模様",
  "item.minecraft.mojang_banner_pattern": "旗の模様□何かの模様",
  "item.minecraft.globe_banner_pattern": "旗の模様□地球の模様",
  "item.minecraft.piglin_banner_pattern": "旗の模様□ブタの鼻の模様",
  "block.minecraft.composter": "コンポスター",
  "block.minecraft.barrel": "樽",
  "block.minecraft.smoker": "燻製器",
  "block.minecraft.blast_furnace": "溶鉱炉",
  "block.minecraft.cartography_table": "製図台",
  "block.minecraft.fletching_table": "矢細工台",
  "block.minecraft.grindstone": "砥石",
  "block.minecraft.lectern": "書見台",
  "block.minecraft.smithing_table": "鍛冶台",
  "block.minecraft.stonecutter": "石切台",
  "block.minecraft.bell": "鐘",
  "block.minecraft.lantern": "ランタン",
  "block.minecraft.soul_lantern": "魂のランタン",
  "item.minecraft.sweet_berries": "スイートベリー",
  "block.minecraft.campfire": "焚き火",
  "block.minecraft.soul_campfire": "魂の焚き火",
  "block.minecraft.shroomlight": "シュルームライト",
  "item.minecraft.honeycomb": "ハニカム",
  "block.minecraft.bee_nest": "ミツバチの巣",
  "block.minecraft.beehive": "養蜂箱",
  "item.minecraft.honey_bottle": "ハチミツ入りの瓶",
  "block.minecraft.honey_block": "ハチミツブロック",
  "block.minecraft.honeycomb_block": "ハニカムブロック",
  "block.minecraft.lodestone": "ロードストーン",
  "block.minecraft.netherite_block": "ネザライトブロック",
  "block.minecraft.ancient_debris": "古代の残骸",
  "block.minecraft.target": "的",
  "block.minecraft.crying_obsidian": "泣く黒曜石",
  "block.minecraft.blackstone": "ブラックストーン",
  "block.minecraft.blackstone_slab": "ブラックストーンのハーフブロック",
  "block.minecraft.blackstone_stairs": "ブラックストーンの階段",
  "block.minecraft.gilded_blackstone": "きらめくブラックストーン",
  "block.minecraft.polished_blackstone": "磨かれたブラックストーン",
  "block.minecraft.polished_blackstone_slab": "磨かれたブラックストーンのハーフブロック",
  "block.minecraft.polished_blackstone_stairs": "磨かれたブラックストーンの階段",
  "block.minecraft.chiseled_polished_blackstone": "模様入りの磨かれたブラックストーン",
  "block.minecraft.polished_blackstone_bricks": "磨かれたブラックストーンレンガ",
  "block.minecraft.polished_blackstone_brick_slab": "磨かれたブラックストーンレンガのハーフブロック",
  "block.minecraft.polished_blackstone_brick_stairs": "磨かれたブラックストーンレンガの階段",
  "block.minecraft.cracked_polished_blackstone_bricks": "ひび割れたブラックストーンレンガ",
  "block.minecraft.respawn_anchor": "リスポーンアンカー",
}
export const ja_jp = items; 
